import regEx from 'utils/global/regEx'

export type LinkKind = 'none' | 'external' | 'protocol' | 'internal'

const PROTOCOL_LINK = /^(mailto|tel):/i
const WEB_PROTOCOLS = new Set(['http:', 'https:'])

const isExternal = (link: string): boolean => {
  if (!regEx.urlScheme.test(link)) return false
  try {
    return WEB_PROTOCOLS.has(new URL(link, window.location.origin).protocol)
  } catch {
    return false
  }
}

/**
 * How the app follows a link: `external` only for an absolute `http(s)://`
 * URL, `protocol` only for a value that starts with `mailto:` or `tel:`, and
 * `internal` for everything else, so a `javascript:`, `data:` or `vbscript:`
 * value is never opened as a page.
 */
export const determineLink = (link: string | null | undefined): LinkKind => {
  if (!link) return 'none'
  if (isExternal(link)) return 'external'
  if (PROTOCOL_LINK.test(link)) return 'protocol'
  return 'internal'
}

export default determineLink
